import PropTypes from 'prop-types';
import SimpleDropdown from '../SimpleDropdown.jsx';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

const MonthSelector = ({ selectedMonth, selectedYear, onMonthChange }) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();
  
  // Generate list of available months (from Jan 2024 to current month)
  const availableMonths = [];
  const startYear = 2024;
  
  for (let year = startYear; year <= currentYear; year++) {
    const endMonth = year === currentYear ? currentMonth : 12;
    for (let month = 1; month <= endMonth; month++) {
      availableMonths.push({ month, year });
    }
  }
  
  // Reverse to show most recent first
  availableMonths.reverse();
  
  // Transform to options format
  const options = availableMonths.map(({ month, year }) => ({
    label: `${MONTHS[month - 1]} ${year}`,
    value: `${year}-${month}`
  }));
  
  const selectedValue = `${selectedYear}-${selectedMonth}`;
  
  const handleChange = (value) => {
    const [year, month] = value.split('-').map(Number);
    onMonthChange(month, year);
  };
  
  return (
    <SimpleDropdown
      value={selectedValue}
      onChange={handleChange}
      options={options}
      width="w-[194px]"
    />
  );
};

MonthSelector.propTypes = {
  selectedMonth: PropTypes.number.isRequired,
  selectedYear: PropTypes.number.isRequired,
  onMonthChange: PropTypes.func.isRequired,
};

export default MonthSelector;
